import React, { Component } from 'react';
import { withFirebase } from 'react-redux-firebase';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { styles } from './dockPadStyle';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { dialogActions } from '../actions/dialog.actions';
import { userActions } from '../actions/user.actions';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Select, MenuItem } from '@material-ui/core';
import { Roles } from '../utils/Roles';
import MaterialTable, { MTableToolbar } from 'material-table'
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit';
import { connect } from 'react-redux'
import { getProjectUsers, getProjectId } from '../selectors/project.selector';
import ConstraintDialog from '../components/Dialogs/ConstraintDialogContainer';
import { getTrades, getSelectedPhasePlan, getSelectedPhasePlanId, getConstraintsList, getPhaseTags } from '../selectors/phaseplan.selector';
import { ThunkDispatch } from 'redux-thunk';
import { Constraint, ConstraintStatus } from '../models/Constraint';
import moment from 'moment'
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ColumnType } from '../components/PhasePlan/Column';
import { PhaseTag } from '../models/PhaseTag';

interface Props {
  openConstraintDialog: (constraintId?: string) => void,
  projectUsers: Record<string, any>;
  classes: ClassNameMap;
  phasePlanTags: Record<string, PhaseTag>
}

type State = {
  
}

class ConstraintLog extends Component<Props, State> {
  renderTableContainer() {
    return (
      <React.Fragment>
        {this.renderIssueTable()}
      </React.Fragment>
    );
  }

  formatObjectsToArrays(itemMap, type, roles = {}) {
    const map = [];
    for (const key in itemMap) {
      const item = Object.assign({}, itemMap[key]);
      item['uid'] = key;
      item['type'] = type;
      item['role'] = roles[key];
      map.push(Object.freeze(item));
    }

    return map;
  }

  updateUserRole(row, event) {
    const { dispatch, projectId } = this.props;

    dispatch(
      userActions.changeUserRole(projectId, row.uid, event.target.value)
    );
  }
  decideRole(role) {
    if (!role) {
      return Roles.ADMIN;
    } else {
      return role.type;
    }
  }
  renderRolesDropDown(row) {
    const { currentUserId, currentUserRole } = this.props;
    const role = this.decideRole(row.role);
    if (row.uid === currentUserId) {
      return role;
    }

    if (currentUserRole !== Roles.ADMIN) {
      return role;
    }

    return (
      <Select
        value={role}
        onChange={event => {
          this.updateUserRole(row, event);
        }}
      >
        <MenuItem value={Roles.ADMIN}>Admin</MenuItem>
        <MenuItem value={Roles.COLLABORATOR}>Collaborator</MenuItem>
        <MenuItem value={Roles.VIEWER}>Viewer</MenuItem>
      </Select>
    );
  }

  renderProjectUser(row) {
    return (
      <TableRow key={row.uid}>
        <TableCell>
          {row.first_name} {row.last_name}
        </TableCell>
        <TableCell>{this.renderRolesDropDown(row)}</TableCell>
        <TableCell>{row.phone_number}</TableCell>
        <TableCell>{row.email}</TableCell>
      </TableRow>
    );
  }

  renderOwnerData(rowData) {
    const { projectUsers } = this.props;
    const ownersList = [];
    for (let ownerUserId in rowData.owners) {
      let owner = `${projectUsers[`${ownerUserId}`].first_name} ${projectUsers[`${ownerUserId}`].last_name} ${projectUsers[`${ownerUserId}`].email} `
      ownersList.push(owner)
    }

    return ownersList.join(', ')
  }

  renderIdentifyByData(rowData:Constraint) {
    const { projectUsers } = this.props;
    if(!rowData.identifyBy || !projectUsers[rowData.identifyBy]) {
      return ''
    }

    return `${projectUsers[rowData.identifyBy].first_name} ${projectUsers[rowData.identifyBy].last_name} - ${projectUsers[rowData.identifyBy].email}`
  }

  renderStatusData(rowData: Constraint) {
    const { classes } = this.props;

    if(rowData.status === ConstraintStatus.Todo) {
      return <Chip label="Todo"className={classNames(classes.issuesTableStatusNotDone)} />
    }

    if (rowData.status === ConstraintStatus.WorkingOn){
      return <Chip label="Working On" className={classNames(classes.issuesTableStatusDone)} />
    }

    if (rowData.status === ConstraintStatus.Done){
      return <Chip label="Done" className={classNames(classes.issuesTableStatusDone)} />
    }

    if (rowData.status === ConstraintStatus.DoneDone){
      return <Chip label="Done Done" className={classNames(classes.issuesTableStatusDone)} />
    }

    return <Chip label="Error" className={classNames(classes.issuesTableStatusError)}/>
  }

  renderDateCreated(rowData) {
    return moment(rowData.createdAt).calendar()
  }

  renderDateFinished(rowData) {
    return moment(rowData.dateToComplete).calendar()
  }

  renderTag = (rowData:Constraint) => {
    console.log('renderTag',rowData)
    const { phasePlanTags } = this.props
    if(rowData.tagType === ColumnType.PhasePlan) {
      if(!!phasePlanTags && !!phasePlanTags[rowData.tagId]) {
        const tag = phasePlanTags[rowData.tagId] as PhaseTag

        return tag.name
      }

    }
  }

  renderEdit(rowData:Constraint) {
    const { openConstraintDialog, classes } = this.props;
    return (
      <IconButton
        onClick={() => {
          openConstraintDialog(rowData.uid);
        }}>
        <EditIcon
          className={classNames(classes.AllTasksScreenVisibilityIcon)}
        />
      </IconButton>
    )
  }

  renderAssignedTo = (rowData: Constraint) => {
    console.log('renderIdentifyByData', rowData.assignedTo, this.props.projectUsers, )
    const { projectUsers } = this.props;
    if(!rowData.assignedTo || !projectUsers[rowData.assignedTo]) {
      return ''
    }

    return `${projectUsers[rowData.assignedTo].first_name} ${projectUsers[rowData.assignedTo].last_name} - ${projectUsers[rowData.assignedTo].email}`
  }

  renderIssueTable() {

    const { classes, constraintList } = this.props;

    return (
      <MaterialTable
        className={classNames(classes.AllTasksScreenStyle)}
        components={{
          Toolbar: props => (
            <div className={classNames(classes.AllTasksScreenTableHeader)}>
              <MTableToolbar {...props} />
            </div>
          )
        }}
        columns={[
          {
            title: '',
            field: 'edit',
            render: rowData => {
              return this.renderEdit(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px'
            },
            headerStyle: {
               padding: '4px'
           }
          },
          {
            title: 'Date Identify',
            render: (rowData:Constraint) => {
              return moment(rowData.dateCreated).format('L')
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          },
          {
            title: 'Individual Identifying Constraint',
            field: 'identifyBy',
            render: rowData => {
              return this.renderIdentifyByData(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          },
          {
            title: 'Description',
            field: 'description',
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          },
          
          {
            title: 'Date to be Resolved',
            field: 'dueByDate',
            render: (rowData:Constraint) => {
              return moment(rowData.dueByDate).format('L')
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          },
          {
            title: 'Tag',
            render: rowData => {
              return this.renderTag(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          },
          {
            title: 'Responsible Individual for Resolving',
            render: rowData => {
              return this.renderAssignedTo(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          },
          {
            title: 'Status',
            field: 'status',
            render: rowData => {
              return this.renderStatusData(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px 16px'
            },
            headerStyle: {
               padding: '4px 16px'
           }
          }
        ]}
        data={constraintList}
        title=""
        options={{
          pageSize: 10
        }}
      />
    );
  }

  onButtonClick = () => {
    const { openConstraintDialog } = this.props;
    console.log('openConstraintDialog')
    openConstraintDialog()
  }

  renderAddIssueButton() {

    return (
      <Button
        onClick={this.onButtonClick}
        variant="outlined"
        color="primary"
      >
        Add Constraint
      </Button>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <ConstraintDialog />
        <div className={classNames(classes.pageContainer)}>
          <Typography
            className={classNames(classes.sectionPaperHeader)}
            variant="headline"
            noWrap
          >
            Constraint Log
          </Typography>
          <div className={classNames(classes.profilePaperTitle)}>
            {this.renderAddIssueButton()}
          </div>
          {this.renderTableContainer()}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
    trades: getTrades(state),
    projectId: getProjectId(state),
    selectedPhasePlan: getSelectedPhasePlan(state),
    selectedPhasePlanId: getSelectedPhasePlanId(state),
    constraintList: getConstraintsList(state),
    projectUsers: getProjectUsers(state),
    phasePlanTags: getPhaseTags(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
      openConstraintDialog: (constaintId?: string) => dispatch(dialogActions.openConstraintDialog(constaintId))
  }
};

export default compose(
  withRouter,
  withFirebase,
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(ConstraintLog);



// WEBPACK FOOTER //
// ./src/containers/ConstraintLog.tsx